import React from 'react'
import { Flex, Box } from 'reflexbox/styled-components'

import { Title } from 'components/Typography'

import PartnerOrderHistoryTable from 'containers/PartnerOrderHistoryTable'

const OrderHistory = () => (
  <Flex flexDirection='column'>
    <Box mb={24}>
      <Title as='h3'>Histórico de pedidos</Title>
    </Box>
    <PartnerOrderHistoryTable />
  </Flex>
)

export default OrderHistory
